// config.ts

export type MetricType = 'leads' | 'contacts' | 'deals' | 'accounts' | 'tasks-completed' | 'tasks-delayed' | 'calls' | 'emails' | 'meetings' | 'followup';

export interface MetricCard {
  title: string;
  type: MetricType;
  current: number;
  total: number;
  icon?: React.ReactNode; // For the bottom row
  bgColor?: string; // For the bottom row background
}

export type PerformanceAlertType = 'danger' | 'warning' | 'success';

export interface BdePerformanceEntry {
  employee: {
    name: string;
    id: string;
    avatarUrl: string; // Use a placeholder or actual image URL
  };
  alert: {
    type: PerformanceAlertType;
    message: string;
  };
}

// --- Dashboard Data ---

// Top/Middle Left Metrics
export const topMetricsConfig: MetricCard[] = [
  {
    title: 'New Leads Added',
    type: 'leads',
    current: 24,
    total: 2512,
  },
  {
    title: 'New Contact Added',
    type: 'contacts',
    current: 24,
    total: 2512,
  },
  {
    title: 'New Deals Created',
    type: 'deals',
    current: 24,
    total: 2512,
  },
  {
    title: 'Tasks Completed',
    type: 'tasks-completed',
    current: 24,
    total: 2512,
  },
  {
    title: 'New Account Added',
    type: 'accounts',
    current: 24,
    total: 2512,
  },
  {
    title: 'Tasks Delayed',
    type: 'tasks-delayed',
    current: 12,
    total: 2512,
  },
];

// Bottom Metrics (Activity Log)
export const bottomMetricsConfig: MetricCard[] = [
  {
    title: 'Calls Made',
    type: 'calls',
    current: 223,
    total: 2512,
    icon: <span className="text-xl">📞</span>,
    bgColor: 'bg-red-100', // Adjusted to match the red icon in the image
  },
  {
    title: 'Emails Sent',
    type: 'emails',
    current: 223,
    total: 2512,
    icon: <span className="text-xl">📧</span>,
    bgColor: 'bg-blue-100',
  },
  {
    title: 'Meetings Done',
    type: 'meetings',
    current: 223,
    total: 2512,
    icon: <span className="text-xl">🗓️</span>,
    bgColor: 'bg-teal-100',
  },
  {
    title: 'Follow-up',
    type: 'followup',
    current: 223,
    total: 2512,
    icon: <span className="text-xl">✅</span>,
    bgColor: 'bg-green-100',
  },
];

// BDE Performance Data
export const bdePerformanceConfig: BdePerformanceEntry[] = [
  {
    employee: {
      name: 'Priya Sharma',
      id: 'AG-0000',
      avatarUrl: 'https://via.placeholder.com/150', // Placeholder
    },
    alert: {
      type: 'danger',
      message: 'No developer deployment this month',
    },
  },
  {
    employee: {
      name: 'Priya Sharma',
      id: 'AG-0000',
      avatarUrl: 'https://via.placeholder.com/150', // Placeholder
    },
    alert: {
      type: 'warning',
      message: 'Slightly behind on monthly account target',
    },
  },
  {
    employee: {
      name: 'Priya Sharma',
      id: 'AG-0000',
      avatarUrl: 'https://via.placeholder.com/150', // Placeholder
    },
    alert: {
      type: 'success',
      message: 'Exceeded lead creation target by 25%',
    },
  },
  {
    employee: {
      name: 'Priya Sharma',
      id: 'AG-0000',
      avatarUrl: 'https://via.placeholder.com/150', // Placeholder
    },
    alert: {
      type: 'warning',
      message: 'Slightly behind on monthly account target',
    },
  },
];